<template>
	<b-row class="align-items-center mb-4">
		<b-col lg="auto" md="12"><h1 class="mh-page-title mb-md-0">{{title}}</h1></b-col>
		<b-col v-if="message != null || data != null" lg="" md="12" class="p-0">
			<span v-if="message != null" class="mh-page-note">{{message}}</span>
			<TextScroller v-if="data != null" :data="data" noDataText="No alerts to display" />
		</b-col>
	</b-row>
</template>

<script>
	import TextScroller from "./TextScroller"

    export default {
		name: 'ContentTitle',
		components: {
			TextScroller
		},
		props: {
			title: "",
			message: "",
			data: null
		}
    };
</script>

<style scoped>
</style>